<template>
  <div>
    <transition name="slide-fade" mode="out-in">
      <form novalidate @submit.prevent="submit" v-if="state === 0 || state === 2"><!-- edit -->
        <PassportDataNotChangableNotice v-if="verified" />
        <div class="row">
          <div class="col">
            <h3 v-if="showHeader">Личные данные</h3>
            <div class="group">
              <Input 
                type="text" 
                caption="Фамилия:"
                :maxLength="255"
                :small="true"
                bgColor="azure"
                @on-input="lastNameInput"
                :isError="invalidValue(lastNameError)"
                :textError="errorTextLastName"
                :value="lastName"
                :hideTextLength="true"
                :disabled="verified"
              />
              <Input 
                type="text" 
                caption="Имя:"
                :maxLength="255"
                :small="true"
                bgColor="azure"
                @on-input="firstNameInput"
                :isError="invalidValue(firstNameError)"
                :textError="errorTextFirstName"
                :value="firstName"
                :hideTextLength="true"
                :disabled="verified"
              />
              <Input 
                type="text" 
                caption="Отчество:"
                :maxLength="255"
                :small="true"
                bgColor="azure"
                @on-input="middleNameInput"
                :isError="invalidValue(middleNameError)"
                :textError="errorTextMiddleName"
                :value="middleName"
                :hideTextLength="true"
                :disabled="verified"
              />
              <Input 
                type="text"
                caption="Имя и фамилия на английском языке:"
                :maxLength="255"
                :small="true"
                bgColor="azure"
                :value="nameForCard"
                :isError="invalidValue(nameForCardError)"
                :textError="errorTextNameForCard"
                :upperCase="true"
                @on-input="nameForCardInput"
                :hideTextLength="true"
              /> <!-- nameForCard -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col" disabled v-if="showWaitDataUser">
            <button class="btn btn-primary" type="button">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Загрузка...
            </button>
          </div>
          <template v-else>
            <div class="col">
              <button type="submit" class="btn btn-primary mr-1">
                Сохранить
              </button>
              <button type="button" class="btn btn-outline-info" @click="cancel()" v-if="state !== 2">
                Отменить
              </button>
            </div>
          </template>
        </div>
      </form>
      <div v-else>
        <div class="row"><!-- read -->
          <div class="col">
            <h3 v-if="showHeader">Личные данные</h3>
            <button class="btn btn-secondary btn-sm float-right changeDataButton"  @click="state=0" v-if="smallEditButton">Изменить</button>
            <div class="group">
              <div class="row">
                <div class="col text-right text-muted">Фамилия:</div>
                <div class="col">{{ lastName }}</div>
              </div>
              <div class="row">
                <div class="col text-right text-muted">Имя:</div>
                <div class="col">{{ firstName }}</div>
              </div>
              <div class="row">
                <div class="col text-right text-muted">Отчество:</div>
                <div class="col">{{ middleName }}</div>
              </div>
              <div class="row">
                <div class="col text-right text-muted">Имя и фамилия на английском языке:</div>
                <div class="col">{{ nameForCard.toUpperCase() }}</div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <button type="button" class="btn btn-outline-info" @click="state=0" v-if="!smallEditButton">
                  Редактирование
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Input from '@/components/Input.vue'
import { minLength, testLastname, testFirstname, testMiddlename, testNameForCard, trim } from '@/utils/Validate.js'
import PassportDataNotChangableNotice from './PassportDataNotChangableNotice.vue'

const upperFirstLowOthers = (str) => {
  // Фамилия может содержать дефис, каждую часть делаем заглавной
  return str.split('-').map(part => {
    if (!part) return part;
    return part[0].toUpperCase() + part.slice(1).toLowerCase();
  }).join('-');
};

export default {
  props: {
      showHeader: {
          type: Boolean,
          default: true
      },
      smallEditButton: {
          type: Boolean,
          default: false
      }
  },
  components: {
    Input,
    PassportDataNotChangableNotice,
  },
  data() {
    return {
      lastName: this.$store.getters.getUserData.memberInfo?.lastname || '',       // фамилия
      lastNameError: {
        minLength: false,
        wrongSymbol: false
      },
      firstName: this.$store.getters.getUserData.memberInfo?.firstname || '',     // имя
      firstNameError: {
        minLength: false,
        wrongSymbol: false
      },
      middleName: this.$store.getters.getUserData.memberInfo?.middlename || '',   // отчество
      middleNameError: {
        minLength: false,
        wrongSymbol: false
      },
      nameForCard: this.$store.getters.getUserData.memberInfo?.nameForCard || '', // фио на англ
      nameForCardError: {
        minLength: false,
        wrongSymbol: false
      },
      showWaitDataUser: false,
      state: 1                                                                    // режим 0 - редактирование, 1 - просмотр, 2 - только редактирвоание
    }
  },
  mounted() {
    this.firstLoad()
  },
  computed: {
    errorTextLastName: function() {
      let error = "";
      if (this.lastNameError.wrongSymbol) error = "Только кириллица"
      if (this.lastNameError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    errorTextFirstName: function() {
      let error = "";
      if (this.firstNameError.wrongSymbol) error = "Только кириллица"
      if (this.firstNameError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    errorTextMiddleName: function() {
      let error = "";
      if (this.middleNameError.wrongSymbol) error = "Только кириллица"
      if (this.middleNameError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    errorTextNameForCard: function() {
      let error = "";
      if (this.nameForCardError.wrongSymbol) error = "Имя и фамилия латинскими буквами"
      if (this.nameForCardError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    verified() {
        return this.$store.getters.getUserData.memberInfo?.isPassportDataVerified;
    },
  },
  methods: {
    invalidValue(obj) {           // Проверяем значение на ошибки
      for (let key in obj) {
        if (obj[key]) return true
      }
      return false
    },
    lastNameInput(value) {
      value = trim(value);
      this.lastNameError.minLength = minLength(value)
      this.lastNameError.wrongSymbol = !testLastname(value)
      this.lastName = value
    },
    firstNameInput(value) {
      value = trim(value);
      this.firstNameError.minLength = minLength(value)
      this.firstNameError.wrongSymbol = !testFirstname(value)
      this.firstName = value
    },
    middleNameInput(value) {
      value = trim(value);
      this.middleNameError.minLength = minLength(value)
      this.middleNameError.wrongSymbol = !testMiddlename(value)
      this.middleName = value
    },
    nameForCardInput(value) {
      value = trim(value).replace(/\s+/, ' ');
      this.nameForCardError.minLength = minLength(value)
      this.nameForCardError.wrongSymbol = !testNameForCard(value)
      this.nameForCard = value

      this.$emit('nameForCardInput', value)
    },
    submit() {
      this.lastNameError.minLength = minLength(this.lastName)
      this.firstNameError.minLength = minLength(this.firstName)
      this.middleNameError.minLength = minLength(this.middleName)
      this.nameForCardError.minLength = minLength(this.nameForCard)
      this.nameForCard = this.nameForCard.toUpperCase();

      this.lastName   = upperFirstLowOthers( this.lastName );
      this.firstName  = upperFirstLowOthers( this.firstName );
      this.middleName = upperFirstLowOthers( this.middleName );

      // проверка
      if (!this.invalidValue(this.lastNameError) && 
          !this.invalidValue(this.firstNameError) &&
          !this.invalidValue(this.middleNameError) &&
          !this.invalidValue(this.nameForCardError)) {
            // submit
            const data = new FormData()
            data.append('lastname', this.lastName)
            data.append('firstname', this.firstName)
            data.append('middlename', this.middleName)
            data.append('nameForCard', this.nameForCard)

            this.showWaitDataUser = true
            this.$store.dispatch('saveInfo', data)
            .then(() => {
              this.state = 1
              this.$emit("accept");
              this.$store.dispatch('loginWithCookie')
              .then(() => {
                this.cancel()
              })
            })
            .finally(() => {
              this.showWaitDataUser = false
            })
      }
    },
    cancel() {
      this.state = 1
      this.lastName = this.$store.getters.getUserData.memberInfo?.lastname || ''
      this.firstName = this.$store.getters.getUserData.memberInfo?.firstname || ''
      this.middleName = this.$store.getters.getUserData.memberInfo?.middlename || ''
      this.nameForCard = this.$store.getters.getUserData.memberInfo?.nameForCard || ''
      this.$emit('nameForCardInput', "")
      this.firstLoad()
    },
    firstLoad() {
      if (!this.$store.getters.isUserDataFilled) {
        this.state = 2;
      }
    }
  }
}
</script>

<style scoped>
  .group {
    border-left: 5px groove rgba(0, 174, 255, 0.959);
    padding-left: 10px;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
